module.exports = __webpack_public_path__ + "images/362NG.jpg";